import Collection from "../../data-structures/collection";
import Department from "./department";
import {BUS_DEPARTMENTS_CHANGED} from "./@const";


export default class Departments extends Collection<Department> {

    constructor(departments:Department[]=[]) {
        super(departments)

        this.onChangeBusEvent = BUS_DEPARTMENTS_CHANGED
    }

    sort() {
        this.models = _.sortBy(this.models, 'name')
    }

    resetFromJson(data:JSONArray):void {

        const models : Department[] = []
        _.map(data, (data:JSONObject)=>{
            models.push(new Department(data))
        })

        return this.reset(models)

    }

    // static initFromJson(data:any[]) {
    //
    //     const models : Expense [] = []
    //     _.map(data, (expenseData:any)=>{
    //         models.push(new Expense(expenseData))
    //     })
    //
    //     return new Companies(models)
    // }



    // exportToOptions() {
    //
    //     return  _.orderBy(
    //         _.map(this.models, function(m){
    //
    //             return {
    //                 'value'     : m.id,
    //                 'label'     : m.name,
    //                 // @ts-ignore
    //                 'icon'      : m.iconNormal,
    //                 'iconObj'   : m
    //             }
    //         }),
    //         [i=>i.label.toLowerCase()],
    //         ['asc']
    //     );
    //
    // }


    // OLD METHODS - need to support them

    findByCompany(companyId:ID):Department[] {
        // return this.filter(function(model){
        //     return (model.companyId === companyId);
        // })
        return this.models
    }

    filterByCompany(companyId:ID):Departments {
        // return new DepartmentCollection(this.filter(function(model){
        //     return (model.companyId === companyId);
        // }),{parse:true});

        // show we return a clone ?

        return this
    }

    exportToOptions():Option[] {
        return this.models.map(function(department : Department) {
            return {
                value: department.id,
                label: department.name
            }
        })
    }

    resetByCompany(companyId : ID, newData : any[]):void {

        // const oldDepartments = this.findByCompany(companyId);
        //
        // _.each(oldDepartments,function(model : Department) {
        //     this.remove(model,{ silent: true });
        // }.bind(this));
        //
        // _.each(newData,function(obj){
        //     this.add(obj);
        // }.bind(this));

        this.resetFromJson(newData)
    }

}
